import React from 'react'
import { CustomArrowDown, CustomArrowUp, SortWrapper } from '../../../styles'
import { ColumnHeaderWrapper } from './styles'
import TooltipComponent from '../../../../headerTooltip'

const sortClick = (field, sortOptions, eventHandlers) => {
  eventHandlers.setSortOptions({
    direction: sortOptions.direction === 'asc' ? 'desc' : 'asc',
    field
  })
  eventHandlers.setPageNumber(1)
}

export const SortableTableHeader = ({
  field,
  text,
  sortOptions,
  eventHandlers,
  tooltip
}) => (
  <ColumnHeaderWrapper
    data-testid={`sortable-table-header-${field}`}
    onClick={() => sortClick(field, sortOptions, eventHandlers)}
  >
    {text}
    {field === sortOptions.field
      ? (
        <SortWrapper data-testid={`sortable-table-header-${field}`}>
          {sortOptions.direction === 'asc' ? CustomArrowUp : CustomArrowDown}
        </SortWrapper>
      )
      : null
    }
    {tooltip && (
      <TooltipComponent
        toolTip={tooltip.component}
        labelText={tooltip.labelText}
      />
    )}
  </ColumnHeaderWrapper>
)
